import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subjectField", "bodyField", "improveButton", "spinner"]

  improve(event) {
    event.preventDefault()

    const subject = this.subjectFieldTarget.value
    const bodyMarkdown = this.bodyFieldTarget.value

    if (!subject && !bodyMarkdown) {
      alert("Veuillez saisir au moins un sujet ou un contenu à améliorer")
      return
    }

    // Désactiver le bouton et afficher le spinner
    this.improveButtonTarget.disabled = true
    this.improveButtonTarget.classList.add("opacity-50", "cursor-not-allowed")

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }

    // Changer le texte du bouton
    const originalText = this.improveButtonTarget.innerHTML
    this.improveButtonTarget.innerHTML = '⏳ Amélioration en cours...'

    // Appeler l'API avec le bon préfixe locale
    const locale = document.documentElement.lang || 'fr'
    fetch(`/${locale}/admin/bulk_emails/improve_with_ai`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        subject: subject,
        body_markdown: bodyMarkdown
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Erreur lors de l\'amélioration')
      }
      return response.json()
    })
    .then(data => {
      // Mettre à jour les champs avec le contenu amélioré
      this.subjectFieldTarget.value = data.subject
      this.bodyFieldTarget.value = data.body_markdown

      // Animation de feedback
      this.subjectFieldTarget.classList.add('bg-green-50')
      this.bodyFieldTarget.classList.add('bg-green-50')

      setTimeout(() => {
        this.subjectFieldTarget.classList.remove('bg-green-50')
        this.bodyFieldTarget.classList.remove('bg-green-50')
      }, 2000)

      // Notification de succès
      this.showNotification('✨ Contenu amélioré avec succès !', 'success')
    })
    .catch(error => {
      console.error('Erreur:', error)
      this.showNotification('❌ Erreur lors de l\'amélioration. Réessayez.', 'error')
    })
    .finally(() => {
      // Réactiver le bouton
      this.improveButtonTarget.disabled = false
      this.improveButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
      this.improveButtonTarget.innerHTML = originalText

      if (this.hasSpinnerTarget) {
        this.spinnerTarget.classList.add("hidden")
      }
    })
  }

  showNotification(message, type) {
    // Créer une notification toast
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 px-6 py-3 rounded-lg shadow-lg z-50 ${
      type === 'success' ? 'bg-green-500' : 'bg-red-500'
    } text-white font-medium`
    notification.textContent = message

    document.body.appendChild(notification)

    // Supprimer après 3 secondes
    setTimeout(() => {
      notification.classList.add('opacity-0', 'transition-opacity', 'duration-500')
      setTimeout(() => notification.remove(), 500)
    }, 3000)
  }
}
